<div class="row page-header">
    <div class="col-12">
        <h1>History Validation <small>Reference view of bid records that may need correction</small></h1>
    </div>
</div>
@if (!isInitialLoading) {
    <div class="row mb-3">
        <div class="col-12">
            <div class="alert alert-info mb-0">
                This view is read-only. To correct issues, please edit records in
                <a routerLink="/bids/history"><strong>Bid History</strong></a>.
            </div>
        </div>
    </div>

    @if (groups.length === 0) {
        <div class="row">
            <div class="col-12">
                <div class="alert alert-success">All bid records pass validation. No issues found.</div>
            </div>
        </div>
    }

    @for (group of groups; track group.categoryKey; let i = $index) {
        <div class="row mb-4">
            <div class="col-12">
                <h4>{{ group.title }} <small class="text-muted">({{ group.bids.length }})</small></h4>
                <p class="text-muted">{{ group.description }}</p>
                <div class="row">
                    <div class="col-12">
                        <wj-flex-grid
                            [attr.id]="'validationGrid_' + i"
                            appAutoSize
                            [padding]="200"
                            [itemsSource]="group.bids"
                            [isReadOnly]="true"
                            [allowSorting]="'SingleColumn'"
                        >
                            <wj-flex-grid-filter></wj-flex-grid-filter>
                            <wj-flex-grid-column
                                [header]="'Heavy Bid #'"
                                [binding]="'heavyBidNum'"
                                [width]="100"
                                [format]="'D'"
                            ></wj-flex-grid-column>
                            <wj-flex-grid-column [header]="'Job'" [binding]="'job'" [width]="250"></wj-flex-grid-column>
                            <wj-flex-grid-column
                                [header]="'Owner'"
                                [binding]="'ownerId'"
                                [width]="200"
                                [dataMap]="ownersMap"
                            ></wj-flex-grid-column>
                            <wj-flex-grid-column
                                [header]="'Bid Type'"
                                [binding]="'bidTypeId'"
                                [width]="180"
                                [dataMap]="jobTypeMap"
                            ></wj-flex-grid-column>
                            <wj-flex-grid-column
                                [header]="'County'"
                                [binding]="'countyId'"
                                [width]="150"
                                [dataMap]="countiesMap"
                            ></wj-flex-grid-column>
                            <wj-flex-grid-column
                                [header]="'Estimator'"
                                [binding]="'estimatorHrRef'"
                                [width]="160"
                                [dataMap]="allUserMap"
                            ></wj-flex-grid-column>
                            <wj-flex-grid-column [header]="'Bid Date'" [binding]="'bidDate'" [width]="130"></wj-flex-grid-column>
                            <wj-flex-grid-column [header]="'Was Bid'" [binding]="'wasBid'" [width]="70"></wj-flex-grid-column>
                            <wj-flex-grid-column
                                [header]="'VanCon'"
                                [binding]="'vanCon'"
                                [width]="100"
                                [format]="'C0'"
                            ></wj-flex-grid-column>
                            <wj-flex-grid-column
                                [header]="'Low'"
                                [binding]="'low'"
                                [width]="100"
                                [format]="'C0'"
                            ></wj-flex-grid-column>
                            <wj-flex-grid-column
                                [header]="'High'"
                                [binding]="'high'"
                                [width]="100"
                                [format]="'C0'"
                            ></wj-flex-grid-column>
                            <wj-flex-grid-column [header]="'Rank'" [binding]="'rank'" [width]="80"></wj-flex-grid-column>
                            <wj-flex-grid-column
                                [header]="'# Bidders'"
                                [binding]="'numBidders'"
                                [width]="100"
                            ></wj-flex-grid-column>
                        </wj-flex-grid>
                    </div>
                </div>
            </div>
        </div>
    }
}
